import type { PermissionsType } from "../Enum/PermissionsType"
import type { SystemModuleType } from "../Enum/SystemModuleType"

export const canAccessRestrictedPage = (
  permission: PermissionsType | undefined,
  module: SystemModuleType | undefined,
  employeePermissions: string[] | undefined,
  isModuleEnabled: (moduleCode?: SystemModuleType) => boolean,
): boolean => {
  if (permission && !employeePermissions?.includes(permission)) return false
  return isModuleEnabled(module)
}
